module.exports = __webpack_public_path__ + "img/mizhi-back-three@3x.fbcefb1a.png";